export default __webpack_public_path__ + "static/NeueHelveticaPro77CondensedBold-8f3b593358a0eecae7784f851683c5f7.woff";